var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            title:
              _vm.advocate.name +
              " - " +
              (_vm.advocate.active ? "ACTIVE" : "INACTIVE"),
            "header-bg-variant": "success",
            "header-text-variant": "light",
            size: "lg",
            visible: true,
            centered: "",
            "ok-only": ""
          },
          on: { hide: _vm.modalClose },
          scopedSlots: _vm._u([
            {
              key: "modal-header-close",
              fn: function() {
                return [_c("h4", [_vm._v("X")])]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-left",
                      attrs: {
                        variant: "danger",
                        size: "sm",
                        disabled: !_vm.isAllowedToCreateOrEditPerson
                      },
                      on: {
                        click: function($event) {
                          _vm.showDeleteAdvocateModal = true
                        }
                      }
                    },
                    [_vm._v("\n            Delete\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "outline-primary",
                        size: "sm",
                        disabled: !_vm.isAllowedToCreateOrEditPerson
                      },
                      on: {
                        click: function($event) {
                          _vm.showToggleActiveModal = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.advocate.active ? "Deactivate" : "Reactivate"
                          ) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        size: "sm",
                        disabled: !_vm.isAllowedToCreateOrEditPerson
                      },
                      on: { click: _vm.updateAdvocate }
                    },
                    [_vm._v("\n              Update\n          ")]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "personPage" },
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Advocate Name",
                            "label-class": "addpersonlabel",
                            "label-for": "Advocate Name"
                          }
                        },
                        [
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              size: "lg",
                              type: "text",
                              name: "Advocate Name"
                            },
                            model: {
                              value: _vm.advocate.name,
                              callback: function($$v) {
                                _vm.$set(_vm.advocate, "name", $$v)
                              },
                              expression: "advocate.name"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.inputValidationErrors.has(
                                    "Advocate Name"
                                  ),
                                  expression:
                                    "inputValidationErrors.has('Advocate Name')"
                                }
                              ],
                              staticClass: "text-info"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.inputValidationErrors.first(
                                    "Advocate Name"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Organization",
                            "label-class": "addpersonlabel",
                            "label-for": "Organization"
                          }
                        },
                        [
                          _c("b-form-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              id: "organization",
                              "data-vv-name": "Organization",
                              "data-vv-as": "Organization",
                              options: _vm.organizationOptions
                            },
                            model: {
                              value: _vm.advocate.organization,
                              callback: function($$v) {
                                _vm.$set(_vm.advocate, "organization", $$v)
                              },
                              expression: "advocate.organization"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.inputValidationErrors.has(
                                    "Organization"
                                  ),
                                  expression:
                                    "inputValidationErrors.has('Organization')"
                                }
                              ],
                              staticClass: "text-info"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.inputValidationErrors.first(
                                    "Organization"
                                  )
                                )
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.advocate.organization === "Other"
                        ? _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Other Organization",
                                "label-for": "Other Organization"
                              }
                            },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  size: "lg",
                                  type: "text",
                                  name: "Other Organization"
                                },
                                model: {
                                  value: _vm.advocate.organization_otherText,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.advocate,
                                      "organization_otherText",
                                      $$v
                                    )
                                  },
                                  expression: "advocate.organization_otherText"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.inputValidationErrors.has(
                                        "Other Organization"
                                      ),
                                      expression:
                                        "inputValidationErrors.has('Other Organization')"
                                    }
                                  ],
                                  staticClass: "text-info"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.inputValidationErrors.first(
                                        "Other Organization"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Email",
                            "label-class": "addpersonlabel",
                            "label-for": "Email"
                          }
                        },
                        [
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { size: "lg", type: "text", name: "Email" },
                            model: {
                              value: _vm.advocate.email,
                              callback: function($$v) {
                                _vm.$set(_vm.advocate, "email", $$v)
                              },
                              expression: "advocate.email"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.inputValidationErrors.has("Email"),
                                  expression:
                                    "inputValidationErrors.has('Email')"
                                }
                              ],
                              staticClass: "text-info"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.inputValidationErrors.first("Email"))
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Phone",
                            "label-class": "addpersonlabel",
                            "label-for": "phone"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: { size: "lg", type: "text", name: "phone" },
                            model: {
                              value: _vm.advocate.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.advocate, "phone", $$v)
                              },
                              expression: "advocate.phone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { key: _vm.componentKey, attrs: { md: "6" } },
                [
                  _c("ShareAdvocateList", {
                    attrs: {
                      advocateId: _vm.advocate.id,
                      advocateOrganizationOwner:
                        _vm.advocate.organizationOwner.id,
                      personId: _vm.advocate.person
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c("b-card-body", [
                        _c("p", { staticClass: "card-text" }, [
                          _c(
                            "small",
                            {
                              staticClass:
                                "text-muted text-uppercase font-weight-bold"
                            },
                            [_vm._v("First Recorded")]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", { staticClass: "text-muted" }, [
                            _c("b", [_vm._v(" on: ")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("unixToHuman")(
                                    _vm.advocate.createdAt / 1000
                                  )
                                ) +
                                "\n                    "
                            ),
                            _vm._.isObject(_vm.advocate.createdBy)
                              ? _c("div", [
                                  _c("b", [_vm._v(" by: ")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.advocate,
                                          "createdBy.emailAddress",
                                          ""
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "card-text" }, [
                          _c(
                            "small",
                            {
                              staticClass:
                                "text-muted text-uppercase font-weight-bold"
                            },
                            [_vm._v("Last Updated")]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", { staticClass: "text-muted" }, [
                            _c("b", [_vm._v(" on: ")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("unixToHuman")(
                                    _vm.advocate.updatedAt / 1000
                                  )
                                ) +
                                "\n                    "
                            ),
                            _vm._.isObject(_vm.advocate.updatedBy)
                              ? _c("div", [
                                  _c("b", [_vm._v(" by: ")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._.get(
                                          _vm.advocate,
                                          "updatedBy.emailAddress",
                                          ""
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "card-text" }, [
                          _c(
                            "small",
                            {
                              staticClass:
                                "text-muted text-uppercase font-weight-bold"
                            },
                            [_vm._v("Current Record Owner")]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", { staticClass: "text-muted" }, [
                            _c("b", [_vm._v(" by: ")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._.get(
                                    _vm.advocate,
                                    "organizationOwner.title"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "toggleActiveModal",
          staticClass: "tos-modal",
          attrs: {
            visible: _vm.showToggleActiveModal,
            centered: "",
            title: _vm.advocate.active
              ? "Deactivate Advocate"
              : "Reactivate Advocate",
            size: "lg",
            "ok-title": "No, return to Advocate",
            "cancel-title": _vm.advocate.active
              ? "Yes, deactivate"
              : "Yes, reactivate",
            "header-bg-variant": "success",
            "header-text-variant": "light",
            "hide-header-close": "",
            "no-close-on-backdrop": ""
          },
          on: {
            ok: function($event) {
              _vm.showToggleActiveModal = false
            },
            cancel: _vm.toggleAdvocateActiveStatus
          }
        },
        [
          _c("p", [
            _vm._v(
              "\n        Are you sure you want to\n          " +
                _vm._s(_vm.advocate.active ? "deactivate" : "reactivate") +
                "\n        this advocate?\n        This information will be saved in the person record as an\n        " +
                _vm._s(
                  _vm.advocate.active ? "inactive advocate" : "active advocate"
                ) +
                ".\n      "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "deleteAdvocateModal",
          staticClass: "tos-modal",
          attrs: {
            visible: _vm.showDeleteAdvocateModal,
            centered: "",
            title: "Delete Advocate",
            size: "lg",
            "ok-title": "No, return to Advocate",
            "cancel-title": "Yes, delete",
            "header-bg-variant": "success",
            "header-text-variant": "light",
            "hide-header-close": "",
            "no-close-on-backdrop": ""
          },
          on: {
            ok: function($event) {
              _vm.showDeleteAdvocateModal = false
            },
            cancel: _vm.deleteAdvocate
          }
        },
        [
          _c("p", [
            _vm._v(
              "\n        Are you sure you want to delete this advocate? This information will be removed from the person record.\n      "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8eaa4f6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8eaa4f6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/t1/ViewAdvocateModal.vue
// module id = 1577
// module chunks = 0